import Acl from "@/plugins/Acl"

export default class TestHelper{

    static testAttemptsExceeded(schema) {
        if (schema.type != 2) {
            return false
        }

        let acl = new Acl()
        let MAX_ATTEMPS = 3

        if (acl.isWorker() && schema.forms_amount >= MAX_ATTEMPS) {
            return true
        }
        return false
    }
}